import React from "react";
import { css } from "emotion";
import logo from "../assets/img/logo.svg";

const wrapperStyles = css`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  box-shadow: 0 2px 10px 0 rgba(66, 77, 87, 0.2);
  color: #687179;
`;

const logoStyles = css`
  height: 18px;
  margin-right: 8px;
`;

const TopBar: React.FC = () => (
  <div className={wrapperStyles}>
    <img src={logo} className={logoStyles} alt="LiveChat logo" />
    <span>Live Preview</span>
  </div>
);

export default TopBar;
